<ag-grid-angular #grid class="ag-theme-alpine grid" 
                    (gridReady)='onGridReady($event)'
                    (rowSelected)="onRowSelected($event)"
                    (selectionChanged)="onSelectionChanged($event)"
                    (columnGroupOpened) = "onColumnGroupOpened($event)"
                    (cellValueChanged)="onCellValueChanged($event)" 
                    [gridOptions]='gridOptions' 
                    [rowData]="rowData" 
                    [columnDefs]="columnDefs"
                    [style.height]="gridHeight"
                    [style.width]="gridWidth"
                    [frameworkComponents]="frameworkComponents"
                    [context]="context">
</ag-grid-angular>